"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertDuringInfer = void 0;
const infer_1 = require("../infer");
const insert_1 = require("../insert");
function insertDuringInfer(mod, ctx, inferred, args) {
    const solved = (0, insert_1.solveByArgs)(mod, ctx, inferred.type, args);
    let core = inferred.core;
    for (const insertion of solved.insertions) {
        core = (0, insert_1.insertionApply)(mod, ctx, insertion, core);
    }
    return (0, infer_1.Inferred)(solved.type, core);
}
exports.insertDuringInfer = insertDuringInfer;
//# sourceMappingURL=insertDuringInfer.js.map